<button [ngClass]="buttonClass" [disabled]="disabled || loading" [style]="buttonStyle">
  <ng-container *ngIf="loading; else normalText">
    <span class="spinner"></span> Carregando...
  </ng-container>
  <ng-template #normalText>{{ text }}</ng-template>
</button> 